"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_abstract_service_1 = require("./http.abstract.service");
class CrudService {
    /**
     * Constructor
     * @param controller The url pointing to the services' controller
     * @param http An HttpService implementation which will be used
     */
    constructor(controller, http = new http_abstract_service_1.SimpleHttpService()) {
        this.controller = controller;
        this.http = http;
    }
    /**
     * Create a new instance of the given body.
     * @param body
     */
    post(body, options = {}) {
        return this.http.post(this.controller, body, options);
    }
    /**
     * Get a model by its id.
     * @param id
     * @param options
     */
    get(id, options = {}) {
        return this.http.get([this.controller, id].join("/"), options);
    }
    /**
     * Get multiple models by their id.
     * @param ids
     * @param options
     */
    getMany(ids, options = {}) {
        return this.http.get(this.controller, Object.assign(Object.assign({}, options), { filter: Object.assign(Object.assign({}, options.filter), { _id: { $in: ids } }) }));
    }
    /**
     * Get all models.
     * @param options
     */
    getAll(options = {}) {
        return this.http.get(this.controller, options);
    }
    /**
     * Overwrite the instance of the given model with the provided body.
     * The model to overwrite is defined with by the (_)id in the body object.
     * @param body
     */
    put(body, options = {}) {
        return this.http.put(this.controller, body, options);
    }
    /**
     * Merge the provided body with the instance of the given model in the DB.
     * The model to overwrite is defined with by the (_)id in the body object.
     * @param body
     */
    patch(body, options = {}) {
        return this.http.patch(this.controller, body, options);
    }
    /**
     * Delete a model by its id.
     * @param id
     */
    delete(id, options = {}) {
        return this.http.delete([this.controller, id].join("/"), options);
    }
}
exports.CrudService = CrudService;
//# sourceMappingURL=crud.abstract.service.js.map